/* tslint:disable */
/* eslint-disable */
/**
 * Atelier Roles API
 * L\'Atelier des rôles (BO admin) : référentiel des briques (standard verrouillées, personnalisées administrables), profils (ensembles de rôles appliqués à la création des acteurs) et matrice rôles/portails. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PermissionGroupeDto } from './PermissionGroupeDto';
import {
    PermissionGroupeDtoFromJSON,
    PermissionGroupeDtoFromJSONTyped,
    PermissionGroupeDtoToJSON,
    PermissionGroupeDtoToJSONTyped,
} from './PermissionGroupeDto';

/**
 * 
 * @export
 * @interface GetBriquePermissionsResponse
 */
export interface GetBriquePermissionsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetBriquePermissionsResponse
     */
    nom: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetBriquePermissionsResponse
     */
    estStandard: boolean;
    /**
     * 
     * @type {Array<PermissionGroupeDto>}
     * @memberof GetBriquePermissionsResponse
     */
    groupes: Array<PermissionGroupeDto>;
}

/**
 * Check if a given object implements the GetBriquePermissionsResponse interface.
 */
export function instanceOfGetBriquePermissionsResponse(value: object): value is GetBriquePermissionsResponse {
    if (!('nom' in value) || value['nom'] === undefined) return false;
    if (!('estStandard' in value) || value['estStandard'] === undefined) return false;
    if (!('groupes' in value) || value['groupes'] === undefined) return false;
    return true;
}

export function GetBriquePermissionsResponseFromJSON(json: any): GetBriquePermissionsResponse {
    return GetBriquePermissionsResponseFromJSONTyped(json, false);
}

export function GetBriquePermissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBriquePermissionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nom': json['nom'],
        'estStandard': json['estStandard'],
        'groupes': ((json['groupes'] as Array<any>).map(PermissionGroupeDtoFromJSON)),
    };
}

export function GetBriquePermissionsResponseToJSON(json: any): GetBriquePermissionsResponse {
    return GetBriquePermissionsResponseToJSONTyped(json, false);
}

export function GetBriquePermissionsResponseToJSONTyped(value?: GetBriquePermissionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nom': value['nom'],
        'estStandard': value['estStandard'],
        'groupes': ((value['groupes'] as Array<any>).map(PermissionGroupeDtoToJSON)),
    };
}

